// Login.tsx
import { Typography } from '@mui/material';
import {
  Container,
  Content,
  ForgetPasswordButton,
  FormInstruction,
  LogoStyle,
} from './styles';
import TextField from '@/components/Input/TextField';
import { Link } from 'react-router-dom';
import api from '@/services/api';
import { ErrorMessage, Formik } from 'formik';
import * as Yup from 'yup';
import { useAuth } from '@/hooks/useAuth';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useEffect } from 'react'; // Import useEffect
import { Button } from '@/components/Button';
import { useUser } from '@/context/UserContext';
import { useTranslation } from 'react-i18next';

function Login() {
  const initialValues = {
    email: '',
    password: '',
  };
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const { login } = useAuth();
  const { updateUser } = useUser();

  // Move localStorage.setItem into a useEffect hook
  useEffect(() => {
    localStorage.setItem('previousPath', '/');
  }, []); // Empty dependency array ensures it runs only once on mount

  const handleLogin = async (values: { email: string; password: string }) => {
    console.log('chegou cá');
    try {
      console.log('fez aqui');
      const response = await api.post('/auth/login', {
        email: values.email,
        password: values.password,
      });
      console.log('passou por cá');
      if (response.status === 200) {
        const loggedUser = {
          id: response.data.id,
          name: response.data.name,
          email: response.data.email,
          role: response.data.role,
          image: response.data.image,
        };

        // Udapte context and localStorage at once
        updateUser(loggedUser);

        // if still needs to call login:
        await login(loggedUser);
        console.log('foe');
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          enqueueSnackbar(error.response.data?.detail, { variant: 'error' });
        }
      }
    }
  }; // Yup validation schema

  const loginValidationSchema = Yup.object().shape({
    email: Yup.string()
      .email(t('login.invalidEmail'))
      .required(t('login.requireEmail'))
      .nonNullable(t('login.notNull')),
    password: Yup.string().required(t('config.requirePassword')),
  });

  return (
    <Container>
      <div className="waves" />
      <Content>
        <LogoStyle />
        <Formik
          initialValues={initialValues}
          validationSchema={loginValidationSchema}
          onSubmit={handleLogin}
          validateOnBlur={false}
          validateOnChange={false}
        >
          {({ values, touched, errors, handleChange, submitForm }) => {
            const handleKeyDown = (
              event: React.KeyboardEvent<HTMLInputElement>
            ) => {
              if (event.key === 'Enter') {
                event.preventDefault(); // avoid duplicate submit
                submitForm();
              }
            };

            return (
              <>
                <FormInstruction variant="body2">
                  {t('login.formInstruction')}
                </FormInstruction>

                <TextField
                  name="email"
                  id="email"
                  value={values.email}
                  placeholder="email@email.com"
                  onChange={handleChange}
                  error={touched.email && Boolean(errors.email)}
                  helperText={<ErrorMessage name="email" component="div" />}
                  onKeyDown={handleKeyDown}
                  shadow
                />

                <TextField
                  id="password"
                  name="password"
                  value={values.password}
                  type="password"
                  placeholder="••••••••"
                  onChange={handleChange}
                  error={touched.password && Boolean(errors.password)}
                  helperText={<ErrorMessage name="password" component="div" />}
                  onKeyDown={handleKeyDown}
                  shadow
                />

                <Button
                  variant="secondary"
                  fullWidth={true}
                  type="submit"
                  onClick={submitForm}
                >
                  {t('login.login')}
                </Button>
              </>
            );
          }}
        </Formik>

        <ForgetPasswordButton>
          <Link to="/forget-password">
            <Typography variant="caption">
              {t('login.forgetPassword')}
            </Typography>
          </Link>
        </ForgetPasswordButton>
      </Content>
    </Container>
  );
}

export default Login;
